import COS from "cos-js-sdk-v5";
import {getLocalStorageForUser} from "./localstorage";



let cosUploading = null


class CosUploading {
    token = localStorage.getItem('token')
    AppId = "1319321681"
    SecretId = getLocalStorageForUser(this.token,"tmpSecretId")
    SecretKey =  getLocalStorageForUser(this.token,"tmpSecretKey")
    cos = null
    key = ""
    taskId = ""
    sessionToken = getLocalStorageForUser(this.token,"sessionToken")
    Bucket =  getLocalStorageForUser(this.token,"bucketName")
    Region = getLocalStorageForUser(this.token,"region")
    constructor() {

        this.cos = new COS({
            SecretId: this.SecretId,
            SecretKey: this.SecretKey,
            XCosSecurityToken:this.sessionToken
        })
    }

    uploadFile(key, file, onProgress, onFileFinish, onSuccess) {
        this.cos.uploadFile({
            Bucket: this.Bucket,
            Region: this.Region,
            Key: key,
            Body: file,
            ContentType: file.type,
            SliceSize: 1024 * 1024 * 5,
            onTaskReady: (taskId) => {
                this.taskId = taskId
            },
            onProgress: (progressData) => {

                onProgress(progressData)
            },
            onFileFinish: (err, data, options) => {

                onFileFinish(err, data, options)
            },
        }, (err, data) => {
            onSuccess(err, data)
        });

    }
    cancelTask(taskId) {
        this.cos.cancelTask(taskId)
    }


}


function getCosUploading(forceUpdate = false) {
    // 强制更新或者ossUploading尚未初始化时，创建新的实例
    if (forceUpdate || cosUploading === null) {
        cosUploading = new CosUploading();
    }
    return cosUploading;
}



export default getCosUploading;
